import { inject, Injectable, OnDestroy } from '@angular/core';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { PluginListenerHandle } from '@capacitor/core';
import { Group, GroupResponse, NotificationsResponse, TNotification } from './app.types';
import { firstValueFrom, Observable, ReplaySubject, Subject, Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NavController } from '@ionic/angular/standalone';
import { AuthService } from './auth.service';
import { Preferences } from '@capacitor/preferences';
//import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root'
})
export class MessagingService implements OnDestroy {

  private notificationsSubject = new ReplaySubject<number[] | null>(1)
  public get notificationsStateChange$(): Observable<number[]> {
    return this.notificationsSubject.asObservable()
  }

  private unreadBadgeSubject = new ReplaySubject<number | null>(1)
  public get unreadBadgeStateChange$(): Observable<number> {
    return this.unreadBadgeSubject.asObservable()
  }

  private selectGroupSubject = new ReplaySubject<Group | null>(1)
  public get selectGroupStateChange$(): Observable<Group> {
    return this.selectGroupSubject.asObservable()
  }

  listeners: PluginListenerHandle[] = []
  permissionsGranted = false
  endpoint = "https://api.aitempo.online"
  httpOptions = {
    headers: new HttpHeaders({
      'Authorization': 'Bearer 629ddb523040fcafa3abf9f4f99fb216'
    })
  }

  selectedGroup:Group
  
  constructor(
    private http: HttpClient,
    private navController: NavController
  ) {
    
  }

  async groupById(gid: number) {
      const url = "https://api.aitempo.online/groupById/" + gid
      return firstValueFrom(this.http.get<GroupResponse>(url, this.httpOptions))
    }

  async initializeMessaging(uid: string, gid: number) {
    const result = await FirebaseMessaging.checkPermissions()
    if (result.receive === "prompt") {
      const presult = await FirebaseMessaging.requestPermissions()
      if (presult.receive === "granted") {
        this.permissionsGranted = true
      }
    }
    else if (result.receive === "granted") {
      this.permissionsGranted = true
    }

    if (this.permissionsGranted) {
      const l1 = await FirebaseMessaging.addListener("notificationReceived", async (e) => {
        console.log("notificationReceived", e.notification)
        //this.notificationsSubject.next([e.notification])

        await this.updateBadges(uid, gid)
      })

      const l2 = await FirebaseMessaging.addListener("notificationActionPerformed", async (e) => {
        console.log("[Notification] notificationActionPerformed", JSON.stringify(e.notification,null,2))
        try {
          // qui ci va la logica per navigare alla pagina delle notifiche
          // cambiare gruppo se necessario

          const nid = (e.notification.data as any).nid
          const ns = await this.getNotification(nid)
          if(ns.notifications.length > 0) {
            const n = ns.notifications[0]
            console.log("[Notification] Notification data", JSON.stringify(n,null,2))
            if(n.gid != this.selectedGroup.gid) {
              console.log("[Notification] Notification belongs to group", n.gid, "but current group is", this.selectedGroup.gid)
              // cambiare gruppo
              console.log("[Notification] Changing group to", n.gid)
              const g = await this.groupById(n.gid)
              //this.setSelectedGroup(g.group)
              this.selectGroupSubject.next(g.group)
            }
          }
          

          this.navController.navigateRoot("/tabs/notifications")
          await FirebaseMessaging.removeDeliveredNotifications({ notifications: [e.notification] })
        } catch (error) {
          console.log("navigateForward error", error)
        }
      })

      const l3 = await FirebaseMessaging.addListener("tokenReceived", (e) => {
        console.log("tokenReceived", e.token)
      })

      this.listeners.push(...[l1, l2, l3])
    }
  }

  setSelectedGroup(g: Group) {
    this.selectedGroup = g
  }

  async updateBadges(uid: string, gid: number) {
    const ns = await this.getNotifications(uid, gid)
    const nr = await this.getReadNotifications(gid)
    const unread = ns.notifications.length - nr.length
    await this.updateUnreadBagde(unread)
  }

  async getReadNotifications(gid: number) {
    console.log("getReadNotifications gid",gid)
    const res = await Preferences.get({key:"readNotificationsIds_"+gid})
    if(res.value) {
      return JSON.parse(res.value) as number[]
    }
    return []
  }

  async setReadNotification(nid: number, gid: number) {
    console.log("setReadNotification nid",nid,"gid",gid)
    const res = await this.getReadNotifications(gid)
    if(!res.includes(nid)) {
      res.push(nid)
      await Preferences.set({key:"readNotificationsIds_"+gid, value: JSON.stringify(res)})
    }
    return res
  }

  ngOnDestroy() {
    this.listeners.forEach((l) => l.remove())
  }



  async subscribeToMainTopics(uid: string, gids: number[]) {
    if (!this.permissionsGranted) return
    await FirebaseMessaging.subscribeToTopic({ topic: "user_" + uid })
    for (const gid of gids) {
      await FirebaseMessaging.subscribeToTopic({ topic: "group_" + gid })
    }
    console.log(`Subscribed to main user topic and ${gids.length} channel's topics`)
  }

  async updateUnreadBagde(count: number) {
    this.unreadBadgeSubject.next(count < 0 ? 0 : count)
  }

  async getNotification(nid: number) {
    const url = this.endpoint + "/notification/" + nid
    console.log("calling: " + url)
    return firstValueFrom(this.http.get<NotificationsResponse>(url, this.httpOptions))
  }

  async getNotifications(uid: string, gid: number) {
    const url = this.endpoint + "/notifications/" + uid + "/" + gid
    console.log("calling: " + url)
    return firstValueFrom(this.http.get<NotificationsResponse>(url, this.httpOptions))
  }

  async removeNotification(nid: number) {
    const delivered = await FirebaseMessaging.getDeliveredNotifications()
    console.log("delivered", delivered)

    const nots: any[] = []
    for (const n of delivered.notifications) {
      if ((n.data as any).nid == nid) {
        await FirebaseMessaging.removeDeliveredNotifications({
          notifications: [n]
        })
      }
      nots.push(n)
    }

    this.notificationsSubject.next(nots)
    return nots.map((n) => n.data.nid)
  }

  // async checkNotifications() {
  //   const delivered = await FirebaseMessaging.getDeliveredNotifications()
  //   console.log("delivered", delivered)
  //   //this.notificationsSubject.next(delivered.notifications.length > 0 ? delivered.notifications : null)
  // }

  // async getDelivered() {
  //   const delivered = await FirebaseMessaging.getDeliveredNotifications()
  //   return delivered
  // }
}
